import React from 'react';

const Badge = ({type,children}) => {
    // Tones of the temp worker app Tag: 50 tint background, 700 text.
    const TYPE_COLOR={
        'PRIMARY':'bg-gray-100 text-gray-700',
        'ALERT':'bg-red-50 text-red-700',
        'WARNING':'bg-yellow-50 text-yellow-700',
        'VALID':'bg-green-50 text-green-700',
        'DEFAULT':'border border-gray-200 text-gray-700',
    }

    const tag_color=TYPE_COLOR[type || 'PRIMARY']
    return (
        <>
            <div className={`badge justify-center ${tag_color}`}>
                {children}
            </div>
        </>
    );
};

export default Badge;